import type { Theme } from '@mui/material';

export const styles = {
  inputField: {
    mx: 0,
    mb: 1,
  },

  errorMsg: (theme: Theme) => ({
    textAlign: 'center',
    py: 2,
    color: theme.colors.error[600],
  }),
};
